import { agendaItemSelected } from 'owa-publishedcalendar-agendaview';
import { clearSelectedItem } from 'owa-calendar-surface';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrator needed when an agenda item is selected
 */
orchestrator(agendaItemSelected, () => {
    clearSelectedItem(getSurfaceStore());
});
